export default __webpack_public_path__ + "static/media/js.5f97c471.jpg";